import * as types from "../actionTypes";

export const setFoundersAndPartnersByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_FOUNDERS_AND_PARTNERS_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setFoundersAndPartnersByMonths = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_FOUNDERS_AND_PARTNERS_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceFoundersAndPartnersYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_FOUNDERS_AND_PARTNERS_YEARS,
      key,
      payload,
    });
  };
};

export const resetFoundersAndPartnersRedcucer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_FOUNDERS_AND_PARTNERS_REDUCER,
    });
  };
};
